// extracted by mini-css-extract-plugin
export default {"formCard":"FormCard_formCard__lqM-s","withShadow":"FormCard_withShadow__rTkVn"};